import { render, staticRenderFns } from "./DeptRoleAuthModal.vue?vue&type=template&id=3c4da6d8&scoped=true&"
import script from "./DeptRoleAuthModal.vue?vue&type=script&lang=js&"
export * from "./DeptRoleAuthModal.vue?vue&type=script&lang=js&"
import style0 from "./DeptRoleAuthModal.vue?vue&type=style&index=0&id=3c4da6d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4da6d8",
  null
  
)

export default component.exports